import { PROPERTY, IProperty, Property } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'description' })
export class PropertyDescriptionPipe implements PipeTransform {
  formFields: any[] = [];
  templates: any = {
    property: `We are delighted to present this modern ###furnishing### ###total_rooms### bedroom ###property_type_name### in ###street### ###postcode###
The property is clean, well lit and has fantastic features, such as an <impressive amount of interior space>.
Bills included are ###bills_included###.
Flexible viewing times are available during the day and evening on weekdays and weekends.

To be among the first to contact the Landlord directly for more information, schedule a viewing through Clooper.
Your time investment in viewing this property will be well worth it
      `,
    room: `We are pleased to present this contemporary ###furnishing### bedroom within a ###total_rooms###  bedroom ###property_type_name### in ###street### ###postcode###
The property is modern and decent, with modern accents. It has an <impressive interior design>.
Bills included are ###bills_included###.
On weekdays and weekends, viewing times are flexible during the day and evening.

Schedule a viewing through Clooper to be among the first to contact the Landlord directly for more information.
Your time spent viewing this property will be well worth it.
      `
  }
  descTemplate = `
      A beautiful new built ##furnishing## ##total_rooms## bedroom ##property_type_name## in ##state##, boasting a Private Garden, Garage.
      This property is Fully accessible and is close to station. In the catchment area of great schools, a viewing is highly recommended. £##amount## pcm on a monthly contract with Electricity and Internet bills included.
      Book a viewing through Clooper to avoid agency fees and be one of the first to contact the landlord directly for more information.
    `;

  private buildString(type: string): string {
    let cloneDescTemplate = this.templates[type];
    if (!cloneDescTemplate) return '';
    let result = cloneDescTemplate;
    let buildString = '';
    let templateObj: any = {};
    this.formFields.forEach((field, i) => {
      if (field.name === 'bills_included' && field.value.length == 0) {
        cloneDescTemplate = cloneDescTemplate.replace('Bills included are ###bills_included###.', '')
      }
      let line = '|';
      line = i == 0 ? '' : line;
      buildString = `${buildString}${line}###${field.name}###`;
      templateObj[`###${field.name}###`] = field.value;
    });
    const regex = new RegExp(`${buildString}`, 'gi');
    result = cloneDescTemplate.replace(regex, (matched: any) => templateObj[matched]);
    return result;
  }

  transform(formFields: any, templateType: string = 'property'): string {
    if (!formFields) return '';
    const result: any[] = [];
    const fields: any = formFields;
    Object.keys(fields).forEach((key: any) => {
      let value = fields[key]
      if (value && typeof (value) === "object" && !Array.isArray(value)) {
        Object.keys(value).forEach((nestedKey: any) => {
          const nestedValue = value[nestedKey];
          result.push({ name: nestedKey, value: nestedValue, showEdit: false, })
        })
      } else if (Array.isArray(value)) {
        result.push({ name: key, value: value.join(', '), showEdit: false })
      } else {
        value = typeof (value) == 'string' ? value.toLowerCase() : value
        result.push({ name: key, value, showEdit: false, })
      }
    });
    this.formFields = result;
    return this.buildString(templateType);
  }

}
